import _id from "./id";
import _ref from "./ref";
var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const id_1 = _id;
const ref_1 = _ref;
const core = ["$schema", "$id", "$defs", "$vocabulary", {
  keyword: "$comment"
}, "definitions", id_1.default, ref_1.default];
exports.default = core;
//# sourceMappingURL=index.js.map
export default exports;